<!-- 摘要生成 -->
<template>
    <div class=" min-h-full">
        <!--上传-->
        <UploadAbstract @upload-result="generatorRes" v-if="uploadShow"></UploadAbstract>
        <!--生成-->
        <div v-else>
            <AbstractGeneration></AbstractGeneration>
        </div>
    </div>
</template>

<script>
import UploadAbstract from '@/components/abstract/UploadAbstract.vue';
import AbstractGeneration from '@/components/abstract/AbstractGeneration.vue';

export default {
    components: {
        UploadAbstract,
        AbstractGeneration
    },
    data() {
        return {
            uploadShow: true,
        };
    },
    methods: {
        generatorRes(res) {
            console.log(res);
            this.uploadShow = false;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>